import { Injectable } from '@angular/core';
import { findInArray, getValueProperty } from '../../helpers/functions.helpers';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {
  
  private _scripts: Array<{script:string, loaded: boolean, status: string}> = [];

  constructor() {}

  isLoaded(name:string){
    return getValueProperty(this._scripts, `${name}.loaded`, false);
  }

  loadScript(scriptData: {
    name: string,
    src: string,
    async?: boolean,
    defer?: boolean
  }) {
    return new Promise((resolve, reject) => {

      const scriptLoaded = findInArray(this._scripts, 'name', scriptData.name);
      //resolve if already loaded
      if (getValueProperty(scriptLoaded, `loaded`, false)) {
        resolve(scriptLoaded);
      }
      else {
        //load script
        let script = document.createElement('script') as any;
        script.type = 'text/javascript';
        script.src = scriptData.src;
        script.async = scriptData.async;
        script.defer = scriptData.defer
        if (script.readyState) {  //IE
          script.onreadystatechange = () => {
            if (script.readyState === "loaded" || script.readyState === "complete") {
              script.onreadystatechange = null;
              const scriptProcess = {
                script: scriptData.name, 
                loaded: true, 
                status: 'Loaded'
              };
              this._scripts.push(scriptProcess);
              resolve(scriptProcess);
            }
          };
        } else {  //Others
          script.onload = () => {
            const scriptProcess = {
              script: scriptData.name, 
              loaded: true, 
              status: 'Loaded'
            };
            this._scripts.push(scriptProcess);
            resolve(scriptProcess);
          };
        }
        script.onerror = (error: any) => resolve({ script: scriptData.name, loaded: false, status: 'Loaded' });
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    });
  }

}
